/**
 * ScoreCard — small KPI tile used at the top of the dashboard.
 */
import React from 'react';

export default function ScoreCard({ label, value, hint, accent = 'brand' }) {
    const accents = {
        brand: 'text-brand-700 bg-brand-50',
        green: 'text-green-700 bg-green-50',
        amber: 'text-amber-700 bg-amber-50',
        gray:  'text-gray-700 bg-gray-100',
    };
    const cls = accents[accent] || accents.brand;

    return (
        <div className="bg-white border border-gray-200 rounded-lg p-4">
            <div className="text-xs uppercase tracking-wide text-gray-500">{label}</div>
            <div className="mt-1 flex items-baseline gap-2">
                <span className={`text-2xl font-semibold ${cls.split(' ')[0]}`}>{value}</span>
                {hint && <span className={`text-xs px-2 py-0.5 rounded ${cls}`}>{hint}</span>}
            </div>
        </div>
    );
}
